import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import { ModalTypes } from '../Containers/InfoModal';

interface IModalSlicerState {
	isShow: boolean;
	type: ModalTypes;
	title?: string;
	text: string;
	traceId?: string;

	fullHelp: boolean;
}

const initialState: IModalSlicerState = {
	isShow: false,
	type: ModalTypes.debug,
	title: '',
	text: '',
	traceId: '',
	fullHelp: false,
};

interface ModalState extends ShowMessageType {
	type: ModalTypes;
}

interface ShowMessageType {
	title?: string;
	text: string;
	traceId?: string;
}

export const infoModalSlice = createSlice({
	name: 'modals',
	initialState,
	reducers: {
		showModal: (state, action: PayloadAction<ModalState>) => {
			state.type = action.payload.type;
			state.title = action.payload.title;
			state.text = action.payload.text;
			state.isShow = true;
			state.traceId = action.payload.traceId;
		},
		showError: (state, action: PayloadAction<ShowMessageType>) => {
			state.type = ModalTypes.error;
			state.title = action.payload.title;
			state.text = action.payload.text;
			state.isShow = true;
			state.traceId = action.payload.traceId;
		},
		toggleShowHelpModal: (state, action: PayloadAction<boolean>) => {
			state.isShow = !state.isShow;
			state.type = ModalTypes.help;
			state.fullHelp = !!action.payload;
		},
		unsetShow: (state) => {
			state.isShow = false;
			return state;
		},
		toggleShow: (state) => {
			state.isShow = !state.isShow;
			return state;
		},
	},
});

export const {
	showModal,
	unsetShow,
	toggleShow,
	showError,
	toggleShowHelpModal,
} = infoModalSlice.actions;

export const infoModalActions = infoModalSlice.actions;
export default infoModalSlice;
